import { UserPropertyType } from "@gettactic/api";
import { SelectTeams } from "../SelectTeams";

interface TeamAttendanceFiltersProps {
  teams: string[];
  onTeamsChange: (ids: string[]) => void;
  onSaveFilterData: (type: UserPropertyType, value: string) => void;
  isComponentLoading?: boolean;
  triggerClassName?: string;
  className?: string;
}

export const TeamAttendanceFilters = ({
  teams,
  onTeamsChange,
  isComponentLoading,
  triggerClassName
}: TeamAttendanceFiltersProps) => {
  return (
    <SelectTeams
      includeFavs={true}
      teams={teams}
      onChange={(teamIds: string[] | string) => {
        const teamIdsArray = Array.isArray(teamIds) ? teamIds : [teamIds];
        onTeamsChange(teamIdsArray);
      }}
      disabled={isComponentLoading}
      variant="ghost"
      triggerClassName={triggerClassName}
      splitView={true}
      contentWidth="500px"
    />
  );
};
